import useRepo from '@/nebula/repo';
import { accountSlug as accountSlugConfig } from 'shared/api/query/configs.json';

export default function useAccountSlugs() {
  const repo = useRepo(accountSlugConfig.model);

  return { slugs: repo.entityList };
}
